var _slicedToArray = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 4);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ReadableSmartApi = __webpack_require__(9);

  var WritableSmartApi =
  /*#__PURE__*/
  function (_ReadableSmartApi) {
    _inherits(WritableSmartApi, _ReadableSmartApi);

    function WritableSmartApi() {
      var _this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        validator: validator,
        builder: builder
      };

      _classCallCheck(this, WritableSmartApi);

      // console.log('WritableSmartApi props: ', props);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(WritableSmartApi).call(this, props));

      if (typeof props.builder !== 'function') {
        throw new TypeError('a builder function is required');
      }

      _this.validator = props.validator;
      _this.builder = props.builder;
      return _this;
    }

    _createClass(WritableSmartApi, [{
      key: "create",
      value: function () {
        var _create = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(url, params) {
          var paramsAreValid, _validationResults, body;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  paramsAreValid = true;

                  if (typeof this.validator === 'function') {
                    _validationResults = this.validator(params);
                    paramsAreValid = _validationResults.isValid;
                  }

                  if (paramsAreValid) {
                    _context.next = 4;
                    break;
                  }

                  throw new TypeError("Cannot create entity. ".concat(validationResults.errors.join('. ')));

                case 4:
                  body = this.builder(params); // POST model to smart api

                  return _context.abrupt("return", this.client.post({
                    url: url,
                    body: body
                  }));

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function create(_x, _x2) {
          return _create.apply(this, arguments);
        }

        return create;
      }()
    }, {
      key: "update",
      value: function () {
        var _update = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(url, params) {
          var paramsAreValid, _validationResults2, body;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  paramsAreValid = true;

                  if (typeof this.validator === 'function') {
                    _validationResults2 = this.validator(params);
                    paramsAreValid = _validationResults2.isValid;
                  }

                  if (paramsAreValid) {
                    _context2.next = 4;
                    break;
                  }

                  throw new TypeError("Cannot create entity. ".concat(validationResults.errors.join('. ')));

                case 4:
                  body = this.builder(params); // PUT model to smart api

                  return _context2.abrupt("return", this.client.put({
                    url: url,
                    body: body
                  }));

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function update(_x3, _x4) {
          return _update.apply(this, arguments);
        }

        return update;
      }()
    }, {
      key: "delete",
      value: function () {
        var _delete2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(url) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", this.client.delete({
                    url: url
                  }));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function _delete(_x5) {
          return _delete2.apply(this, arguments);
        }

        return _delete;
      }()
    }]);

    return WritableSmartApi;
  }(ReadableSmartApi);

  module.exports = WritableSmartApi;
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = {
    MANAGE: 'manage',
    REPORTING: 'reporting'
  };
  module.exports = SMART_APIS;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _webpack_require__ = __webpack_require__(10),
      URLSearchParams = _webpack_require__.URLSearchParams;

  function buildSmartUrl(api, networkId, resources, filters) {
    var baseUrl = process.env.SMART_BASE_URL;
    var url = "https://".concat(api, ".").concat(baseUrl, "/").concat(networkId);

    if (resources) {
      // join resources together and append to url
      url += "/".concat(resources.join('/'));
    }

    if (filters) {
      // build search parameters object
      var queryParams = new URLSearchParams();
      filters.forEach(function (filter) {
        queryParams.set(filter.key, filter.value);
      });
      filters = queryParams.toString(); // add filters as query params

      url += "?".concat(filters);
    }

    return url;
  }

  module.exports = {
    buildSmartUrl: buildSmartUrl
  };
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function buildSmartResource(_ref) {
    var fileName = _ref.fileName,
        fileContent = _ref.fileContent,
        clickUrl = _ref.clickUrl;
    var smartResource = {};
    var fileNameRegex = /(?:\.([^.]+))?$/;

    if (!fileName) {
      throw new TypeError('fileName is required');
    } else if (!fileName.match(fileNameRegex)) {
      throw new TypeError('fileName must have extension (i.e. `.png`, `.gif`, etc.)');
    } else {
      smartResource.fileName = fileName;
    }

    if (!fileContent) {
      throw new TypeError('fileContent is required');
    } else {
      smartResource.fileContent = fileContent;
    }

    if (clickUrl) {
      smartResource.clickUrl = clickUrl;
    }

    return smartResource;
  }

  module.exports = {
    buildSmartResource: buildSmartResource
  };
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(5);

  module.exports = __webpack_require__(6);
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("regenerator-runtime");
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var AdvertisersApi = __webpack_require__(7);

  var CampaignsApi = __webpack_require__(11);

  var CreativesApi = __webpack_require__(13);

  var ImageCreativesApi = __webpack_require__(14);

  var InsertionsApi = __webpack_require__(15);

  var ReportsApi = __webpack_require__(17);

  var PagesApi = __webpack_require__(19);

  var SmartQuery = __webpack_require__(21);

  var _webpack_require__2 = __webpack_require__(24),
      formatCampaignDate = _webpack_require__2.formatCampaignDate;

  var CAMPAIGN_STATUS = __webpack_require__(25);

  var util = {
    formatCampaignDate: formatCampaignDate
  };
  var CONSTANTS = {
    CAMPAIGN_STATUS: CAMPAIGN_STATUS
  };
  module.exports = {
    SmartQuery: SmartQuery,
    AdvertisersApi: AdvertisersApi,
    CampaignsApi: CampaignsApi,
    CreativesApi: CreativesApi,
    ImageCreativesApi: ImageCreativesApi,
    InsertionsApi: InsertionsApi,
    ReportsApi: ReportsApi,
    PagesApi: PagesApi,
    CONSTANTS: CONSTANTS,
    util: util
  };
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _webpack_require__3 = __webpack_require__(8),
      buildSmartResource = _webpack_require__3.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__4 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__4.buildSmartUrl;

  var AdvertisersApi =
  /*#__PURE__*/
  function (_WritableSmartApi) {
    _inherits(AdvertisersApi, _WritableSmartApi);

    function AdvertisersApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, AdvertisersApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(AdvertisersApi).call(this, props));
    }

    _createClass(AdvertisersApi, [{
      key: "buildUrl",
      value: function buildUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          advertiserId: null,
          subResource: null,
          filters: null
        };
        var resources = ['advertisers'];

        if (options.advertiserId) {
          resources.push(options.advertiserId);
        }

        if (typeof options.subResource === 'string') {
          resources.push(options.subResource);
        }

        return buildSmartUrl(SMART_APIS.MANAGE, this.networkId, resources, options.filters);
      }
    }]);

    return AdvertisersApi;
  }(WritableSmartApi);

  module.exports = AdvertisersApi;
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function buildSmartResource(_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        description = _ref2.description,
        _ref2$isDirectAdverti = _ref2.isDirectAdvertiser,
        isDirectAdvertiser = _ref2$isDirectAdverti === void 0 ? true : _ref2$isDirectAdverti,
        isHouseAds = _ref2.isHouseAds,
        address = _ref2.address,
        contactName = _ref2.contactName,
        contactEmail = _ref2.contactEmail,
        contactPhoneNumber = _ref2.contactPhoneNumber,
        isArchived = _ref2.isArchived,
        userGroupId = _ref2.userGroupId,
        agencyIds = _ref2.agencyIds,
        domainListId = _ref2.domainListId,
        externalId = _ref2.externalId;
    var smartResource = {};

    if (id) {
      smartResource.id = id;
    } // required by Smart


    if (typeof isDirectAdvertiser !== 'undefined') {
      smartResource.isDirectAdvertiser = isDirectAdvertiser;
    } else {
      throw new TypeError('isDirectAdvertiser is required by Smart');
    }

    if (typeof userGroupId !== 'undefined') {
      smartResource.userGroupId = userGroupId;
    } else {
      throw new TypeError('userGroupId is required by Smart');
    } // only required to create new


    if (name) {
      smartResource.name = name;
    } // this is super required for thomas, not smart


    if (externalId) {
      smartResource.externalId = externalId;
    } else {
      throw new TypeError('externalId is required by Thomas');
    }

    if (description) {
      smartResource.description = description;
    }

    if (contactName) {
      smartResource.contactName = contactName;
    }

    if (contactEmail) {
      smartResource.contactEmail = contactEmail;
    }

    if (contactPhoneNumber) {
      smartResource.contactPhoneNumber = contactPhoneNumber;
    }

    if (address) {
      smartResource.address = address;
    } // not required but will throw error if undefined on request object


    if (typeof isHouseAds !== 'undefined') {
      smartResource.isHouseAds = isHouseAds;
    }

    if (typeof isArchived !== 'undefined') {
      smartResource.isArchived = isArchived;
    }

    if (agencyIds) {
      smartResource.agencyIds = agencyIds;
    }

    if (domainListId) {
      smartResource.domainListId = domainListId;
    }

    return smartResource;
  }

  module.exports = {
    buildSmartResource: buildSmartResource
  };
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ReadableSmartApi =
  /*#__PURE__*/
  function () {
    function ReadableSmartApi(_ref3) {
      var client = _ref3.client,
          networkId = _ref3.networkId;

      _classCallCheck(this, ReadableSmartApi);

      this.networkId = networkId;
      this.client = client;
    }

    _createClass(ReadableSmartApi, [{
      key: "get",
      value: function () {
        var _get = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(url) {
          var responseOptions,
              _args4 = arguments;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  responseOptions = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {
                    bodyType: 'json'
                  };
                  return _context4.abrupt("return", this.client.get({
                    url: url
                  }, responseOptions));

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function get(_x6) {
          return _get.apply(this, arguments);
        }

        return get;
      }()
    }]);

    return ReadableSmartApi;
  }();

  module.exports = ReadableSmartApi;
  /***/
},
/* 10 */

/***/
function (module, exports) {
  module.exports = require("url");
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__5 = __webpack_require__(12),
      buildSmartResource = _webpack_require__5.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var _webpack_require__6 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__6.buildSmartUrl;

  var CampaignsApi =
  /*#__PURE__*/
  function (_WritableSmartApi2) {
    _inherits(CampaignsApi, _WritableSmartApi2);

    function CampaignsApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, CampaignsApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(CampaignsApi).call(this, props));
    }

    _createClass(CampaignsApi, [{
      key: "buildUrl",
      value: function buildUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          campaignId: null,
          subResource: null,
          filters: null
        };
        var resources = ['campaigns'];

        if (options.campaignId) {
          resources.push(options.campaignId);
        }

        if (typeof options.subResource === 'string') {
          resources.push(options.subResource);
        }

        return buildSmartUrl(SMART_APIS.MANAGE, this.networkId, resources, options.filters);
      }
    }]);

    return CampaignsApi;
  }(WritableSmartApi);

  module.exports = CampaignsApi;
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function buildSmartResource(_ref4) {
    var id = _ref4.id,
        name = _ref4.name,
        advertiserId = _ref4.advertiserId,
        externalCampaignId = _ref4.externalCampaignId,
        startDate = _ref4.startDate,
        endDate = _ref4.endDate,
        agencyId = _ref4.agencyId,
        campaignStatusId = _ref4.campaignStatusId,
        description = _ref4.description,
        tradedBy = _ref4.tradedBy,
        traffickedBy = _ref4.traffickedBy,
        globalCapping = _ref4.globalCapping,
        visitCapping = _ref4.visitCapping,
        isArchived = _ref4.isArchived;
    var smartResource = {};

    if (id) {
      smartResource.id = id;
    } // required by Smart


    if (typeof advertiserId !== 'undefined') {
      smartResource.advertiserId = advertiserId;
    } else {
      throw new TypeError('advertiserId is required by Smart');
    }

    if (typeof startDate !== 'undefined') {
      smartResource.startDate = startDate;
    } else {
      throw new TypeError('startDate is required by Smart');
    }

    if (typeof endDate !== 'undefined') {
      smartResource.endDate = endDate;
    } else {
      throw new TypeError('endDate is required by Smart');
    } // only required to create new


    if (name) {
      smartResource.name = name;
    } // this is super required for thomas, not smart


    if (externalCampaignId) {
      smartResource.externalCampaignId = externalCampaignId;
    } else {
      throw new TypeError('externalCampaignId is required by Thomas');
    } // not required


    if (agencyId) {
      smartResource.agencyId = agencyId;
    }

    if (campaignStatusId) {
      smartResource.campaignStatusId = campaignStatusId;
    }

    if (typeof isArchived !== 'undefined') {
      smartResource.isArchived = isArchived;
    }

    if (typeof campaignStatusId !== 'undefined') {
      smartResource.campaignStatusId = campaignStatusId;
    }

    if (description) {
      smartResource.description = description;
    }

    if (tradedBy) {
      smartResource.tradedBy = tradedBy;
    }

    if (traffickedBy) {
      smartResource.traffickedBy = traffickedBy;
    }

    if (globalCapping) {
      smartResource.globalCapping = globalCapping;
    }

    if (visitCapping) {
      smartResource.visitCapping = visitCapping;
    }

    return smartResource;
  }

  module.exports = {
    buildSmartResource: buildSmartResource
  };
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__7 = __webpack_require__(3),
      buildSmartResource = _webpack_require__7.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var _webpack_require__8 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__8.buildSmartUrl;

  var CreativesApi =
  /*#__PURE__*/
  function (_WritableSmartApi3) {
    _inherits(CreativesApi, _WritableSmartApi3);

    function CreativesApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, CreativesApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(CreativesApi).call(this, props));
    }

    _createClass(CreativesApi, [{
      key: "buildUrl",
      value: function buildUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          insertionId: null,
          creativeId: null,
          subResource: null,
          filters: null
        };
        var resources = ['insertions', options.insertionId, 'creatives'];

        if (options.creativeId) {
          resources.push(options.creativeId);

          if (typeof options.subResource === 'string') {
            resources.push(options.subResource);
          }
        }

        return buildSmartUrl(SMART_APIS.MANAGE, this.networkId, resources, options.filters);
      }
    }]);

    return CreativesApi;
  }(WritableSmartApi);

  module.exports = CreativesApi;
  /***/
},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__9 = __webpack_require__(3),
      buildSmartResource = _webpack_require__9.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var _webpack_require__10 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__10.buildSmartUrl;

  var ImageCreativesApi =
  /*#__PURE__*/
  function (_WritableSmartApi4) {
    _inherits(ImageCreativesApi, _WritableSmartApi4);

    function ImageCreativesApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, ImageCreativesApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(ImageCreativesApi).call(this, props));
    }

    _createClass(ImageCreativesApi, [{
      key: "buildUrl",
      value: function buildUrl(creativeId) {
        var resources = ['imagecreatives', creativeId];

        if (!creativeId) {
          throw new Error("creativeId is required for this resource");
        }

        return buildSmartUrl(SMART_APIS.MANAGE, this.networkId, resources, null);
      }
    }]);

    return ImageCreativesApi;
  }(WritableSmartApi);

  module.exports = ImageCreativesApi;
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__11 = __webpack_require__(16),
      buildSmartResource = _webpack_require__11.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var _webpack_require__12 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__12.buildSmartUrl;

  var InsertionsApi =
  /*#__PURE__*/
  function (_WritableSmartApi5) {
    _inherits(InsertionsApi, _WritableSmartApi5);

    function InsertionsApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, InsertionsApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(InsertionsApi).call(this, props));
    }

    _createClass(InsertionsApi, [{
      key: "buildUrl",
      value: function buildUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          insertionId: null,
          subResource: null,
          filters: null
        };
        var resources = ['insertions'];

        if (options.insertionId) {
          resources.push(options.insertionId);
        }

        if (typeof options.subResource === 'string') {
          resources.push(options.subResource);
        }

        return buildSmartUrl(SMART_APIS.MANAGE, this.networkId, resources, options.filters);
      }
    }]);

    return InsertionsApi;
  }(WritableSmartApi);

  module.exports = InsertionsApi;
  /***/
},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function buildSmartResource() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      id: id,
      name: name,
      description: description,
      pageIds: pageIds,
      insertionStatusId: insertionStatusId,
      startDate: startDate,
      endDate: endDate,
      campaignId: campaignId,
      insertionTypeId: insertionTypeId,
      weight: weight,
      externalId: externalId,
      externalDescription: externalDescription,
      deliveryTypeId: deliveryTypeId,
      timezoneId: timezoneId,
      priorityId: priorityId,
      isDeliveryRegulated: isDeliveryRegulated,
      isUsedByGuaranteedDeal: isUsedByGuaranteedDeal,
      isUsedByNonGuaranteedDeal: isUsedByNonGuaranteedDeal,
      voiceShare: voiceShare,
      eventId: eventId,
      isPersonalizedAd: isPersonalizedAd,
      periodicCappingId: periodicCappingId,
      groupCappingId: groupCappingId,
      maxImpressions: maxImpressions,
      maxClicks: maxClicks,
      maxImpressionsPerDay: maxImpressionsPerDay,
      maxClicksPerDay: maxClicksPerDay,
      eventImpressions: eventImpressions,
      isHolisticYieldEnabled: isHolisticYieldEnabled,
      deliverLeftVolumeAfterEndDate: deliverLeftVolumeAfterEndDate,
      globalCapping: globalCapping,
      cappingPerVisit: cappingPerVisit,
      cappingPerClick: cappingPerClick,
      autoCapping: autoCapping,
      periodicCappingImpressions: periodicCappingImpressions,
      periodicCappingPeriod: periodicCappingPeriod,
      isObaIconEnabled: isObaIconEnabled,
      formatId: formatId,
      isArchived: isArchived,
      rateTypeId: rateTypeId,
      rate: rate,
      rateNet: rateNet,
      discount: discount,
      currencyId: currencyId,
      insertionLinkId: insertionLinkId,
      customizedScript: customizedScript,
      salesChannelId: salesChannelId
    };
    var smartResource = {}; // required by Smart

    if (Array.isArray(params.pageIds)) {
      smartResource.pageIds = params.pageIds;
    } else {
      throw new TypeError('pageIds is required by Smart');
    }

    if (typeof params.campaignId !== 'undefined') {
      smartResource.campaignId = params.campaignId;
    } else {
      throw new TypeError('campaignId is required by Smart');
    }

    if (typeof params.startDate !== 'undefined') {
      smartResource.startDate = params.startDate;
    } else {
      throw new TypeError('startDate is required by Smart');
    }

    if (typeof params.endDate !== 'undefined') {
      smartResource.endDate = params.endDate;
    } else {
      throw new TypeError('endDate is required by Smart');
    }

    if (typeof params.deliveryTypeId !== 'undefined') {
      smartResource.deliveryTypeId = params.deliveryTypeId;
    } else {
      throw new TypeError('deliveryTypeId is required by Smart');
    }

    if (typeof params.timezoneId !== 'undefined') {
      smartResource.timezoneId = params.timezoneId;
    } else {
      throw new TypeError('campaignStatusId is required by Smart');
    }

    if (typeof params.priorityId !== 'undefined') {
      smartResource.priorityId = params.priorityId;
    } else {
      throw new TypeError('campaignStatusId is required by Smart');
    }

    if (typeof params.insertionTypeId !== 'undefined') {
      smartResource.insertionTypeId = params.insertionTypeId;
    } else {
      throw new TypeError('campaignStatusId is required by Smart');
    } // only required to create new


    if (params.name) {
      smartResource.name = params.name;
    }

    if (params.weight) {
      smartResource.weight = params.weight;
    } else {
      throw new TypeError('weight is required by Thomas');
    } // add all the other not-undefined values


    Object.entries(params).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      if (typeof value !== 'undefined') {
        smartResource[key] = value;
      }
    });
    return smartResource;
  }

  module.exports = {
    buildSmartResource: buildSmartResource
  };
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__13 = __webpack_require__(18),
      buildSmartResource = _webpack_require__13.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var _webpack_require__14 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__14.buildSmartUrl;

  var ReportsApi =
  /*#__PURE__*/
  function (_WritableSmartApi6) {
    _inherits(ReportsApi, _WritableSmartApi6);

    function ReportsApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, ReportsApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(ReportsApi).call(this, props));
    }

    _createClass(ReportsApi, [{
      key: "buildUrl",
      value: function buildUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          taskId: null,
          instanceId: null,
          subResource: null,
          filters: null,
          simulate: false
        };
        var resources = ['reports'];

        if (options.taskId) {
          resources.push(options.taskId); // instances are a subresource of a specific task

          if (options.instanceId) {
            resources.push('instances');
            resources.push(options.instanceId);
          }
        }

        if (typeof options.subResource === 'string') {
          resources.push(options.subResource);
        }

        var url = buildSmartUrl(SMART_APIS.REPORTING, this.networkId, resources, options.filters);

        if (options.simulate) {
          url += '?simulate=true';
        }

        return url;
      }
    }]);

    return ReportsApi;
  }(WritableSmartApi);

  module.exports = ReportsApi;
  /***/
},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function buildSmartResource() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      startDate: startDate,
      endDate: endDate
    };
    var smartResource = {}; // required 

    if (!params.startDate) {
      throw new Error('Start date required to create report');
    } // required 


    if (!params.endDate) {
      throw new Error('End date required to create report');
    } // add all the other not-undefined values


    Object.entries(params).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      if (typeof value !== 'undefined') {
        smartResource[key] = value;
      }
    });
    return smartResource;
  }

  module.exports = {
    buildSmartResource: buildSmartResource
  };
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var SMART_APIS = __webpack_require__(1);

  var _webpack_require__15 = __webpack_require__(20),
      buildSmartResource = _webpack_require__15.buildSmartResource;

  var WritableSmartApi = __webpack_require__(0);

  var _webpack_require__16 = __webpack_require__(2),
      buildSmartUrl = _webpack_require__16.buildSmartUrl;

  var PagesApi =
  /*#__PURE__*/
  function (_WritableSmartApi7) {
    _inherits(PagesApi, _WritableSmartApi7);

    function PagesApi() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        client: client,
        networkId: networkId
      };

      _classCallCheck(this, PagesApi);

      props.builder = buildSmartResource;
      return _possibleConstructorReturn(this, _getPrototypeOf(PagesApi).call(this, props));
    }

    _createClass(PagesApi, [{
      key: "buildUrl",
      value: function buildUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          pageId: null,
          subResource: null,
          filters: null
        };
        var resources = ['pages'];

        if (options.pageId) {
          resources.push(options.pageId);
        }

        if (typeof options.subResource === 'string') {
          resources.push(options.subResource);
        }

        return buildSmartUrl(SMART_APIS.MANAGE, this.networkId, resources, options.filters);
      }
    }]);

    return PagesApi;
  }(WritableSmartApi);

  module.exports = PagesApi;
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function buildSmartResource(_ref9) {
    var id = _ref9.id,
        externalId = _ref9.externalId,
        name = _ref9.name,
        fullName = _ref9.fullName,
        url = _ref9.url,
        pageGroupId = _ref9.pageGroupId,
        parentPageId = _ref9.parentPageId,
        isArchived = _ref9.isArchived;
    var smartResource = {};

    if (id) {
      smartResource.id = id;
    } // only required to create new


    if (name) {
      smartResource.name = name;
    }

    if (fullName) {
      smartResource.fullName = fullName;
    } // this is super required for thomas, not smart


    if (externalId) {
      smartResource.externalId = externalId;
    } else {
      throw new TypeError('externalId is required by Thomas');
    } // not required


    if (url) {
      smartResource.url = url;
    }

    if (typeof isArchived !== 'undefined') {
      smartResource.isArchived = isArchived;
    }

    if (pageGroupId) {
      smartResource.pageGroupId = pageGroupId;
    }

    if (parentPageId) {
      smartResource.parentPageId = parentPageId;
    }

    return smartResource;
  }

  module.exports = {
    buildSmartResource: buildSmartResource
  };
  /***/
},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var util = __webpack_require__(22);

  var DEBUG_MODES = __webpack_require__(23);

  var SmartQuery =
  /*#__PURE__*/
  function () {
    function SmartQuery(_ref10) {
      var client = _ref10.client,
          username = _ref10.username,
          password = _ref10.password,
          debugMode = _ref10.debugMode;

      _classCallCheck(this, SmartQuery);

      this.username = username;
      this.password = password;
      this.client = client;
      this.debugMode = DEBUG_MODES[debugMode] || DEBUG_MODES.OFF; // create Basic Auth Header from username & password in format Smart requires

      var token = Buffer.from("".concat(username, ":").concat(password)).toString('base64');
      this.auth = "Basic ".concat(token);
    }

    _createClass(SmartQuery, [{
      key: "fetch",
      value: function fetch(_ref11) {
        var url = _ref11.url,
            method = _ref11.method,
            _ref11$body = _ref11.body,
            body = _ref11$body === void 0 ? null : _ref11$body;

        // build URL from input
        // const url = buildSmartUrl(api, this.networkId, resource, resourceId, subResource, subResourceId, filters);
        try {
          // create options object from common headers, method, and potentiall body
          var params = {
            method: method,
            headers: {
              Authorization: this.auth,
              'Content-Type': 'application/json; charset=utf-8'
            },
            body: body
          };

          if (this.debugMode === DEBUG_MODES.VERBOSE) {
            console.log('URL: ', url);
            console.log('PARAMS: ', params);
          }

          return this.client(url, params);
        } catch (error) {
          console.log("Failed to ".concat(method, " from ").concat(url));
          console.log(error);
          return null;
        }
      }
    }, {
      key: "handleResponse",
      value: function () {
        var _handleResponse = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(res, params, responseOptions) {
          var formattedResponse, responseText;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  // Log that something went wrong
                  if (res.status !== 200 && res.status !== 201) {
                    console.log('Request rejected with status: ', res.status);
                    console.log('Rejected request parameters: ', params);
                  }

                  formattedResponse = {
                    status: res.status,
                    statusText: res.statusText
                  };
                  console.log('handleResponse responseOptions: ', responseOptions);

                  if (!(responseOptions.bodyType === 'json')) {
                    _context5.next = 18;
                    break;
                  }

                  _context5.prev = 4;
                  _context5.next = 7;
                  return res.json();

                case 7:
                  responseText = _context5.sent;
                  formattedResponse.body = responseText;
                  _context5.next = 16;
                  break;

                case 11:
                  _context5.prev = 11;
                  _context5.t0 = _context5["catch"](4);
                  console.log('Failed to parse body as json.', formattedResponse);

                  if (this.debugMode === DEBUG_MODES.VERBOSE) {
                    console.log('Full repsonse body: ', util.inspect(res.body));
                  } // add it anyway


                  if (res.body) {
                    formattedResponse.body = res.body;
                  }

                case 16:
                  _context5.next = 19;
                  break;

                case 18:
                  if (responseOptions.bodyType === 'stream' || responseOptions.bodyType === 'text/html') {
                    formattedResponse.body = res.body;
                  } else if (responseOptions.bodyType === 'buffer') {
                    formattedResponse.body = res.buffer();
                  }

                case 19:
                  // Log response if verbose debugging turned on
                  if (this.debugMode === DEBUG_MODES.VERBOSE) {
                    console.log('Smart Response: ', formattedResponse);
                  }

                  return _context5.abrupt("return", formattedResponse);

                case 21:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this, [[4, 11]]);
        }));

        function handleResponse(_x7, _x8, _x9) {
          return _handleResponse.apply(this, arguments);
        }

        return handleResponse;
      }()
    }, {
      key: "get",
      value: function () {
        var _get2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6() {
          var _this2 = this;

          var params,
              responseOptions,
              response,
              _args6 = arguments;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  params = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {
                    url: url
                  };
                  responseOptions = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {
                    bodyType: 'json'
                  };
                  params.method = 'GET';
                  _context6.next = 5;
                  return this.fetch(params).then(function (res) {
                    return _this2.handleResponse(res, params, responseOptions);
                  });

                case 5:
                  response = _context6.sent;
                  console.log('Response: ', response);
                  return _context6.abrupt("return", response);

                case 8:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function get() {
          return _get2.apply(this, arguments);
        }

        return get;
      }()
    }, {
      key: "post",
      value: function () {
        var _post = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7() {
          var _this3 = this;

          var params,
              responseOptions,
              _args7 = arguments;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  params = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {
                    url: url,
                    body: body
                  };
                  responseOptions = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {
                    bodyType: 'json'
                  };
                  params.method = 'POST';
                  params.body = JSON.stringify(params.body);
                  return _context7.abrupt("return", this.fetch(params).then(function (res) {
                    return _this3.handleResponse(res, params, responseOptions);
                  }));

                case 5:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function post() {
          return _post.apply(this, arguments);
        }

        return post;
      }()
    }, {
      key: "put",
      value: function () {
        var _put = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8() {
          var _this4 = this;

          var params,
              responseOptions,
              _args8 = arguments;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  params = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {
                    url: url,
                    body: body
                  };
                  responseOptions = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {
                    bodyType: 'json'
                  };
                  params.method = 'PUT';
                  params.body = JSON.stringify(params.body);
                  return _context8.abrupt("return", this.fetch(params).then(function (res) {
                    return _this4.handleResponse(res, params, responseOptions);
                  }));

                case 5:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function put() {
          return _put.apply(this, arguments);
        }

        return put;
      }()
    }, {
      key: "delete",
      value: function () {
        var _delete3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9() {
          var _this5 = this;

          var params,
              responseOptions,
              _args9 = arguments;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  params = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {
                    url: url
                  };
                  responseOptions = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {
                    bodyType: 'json'
                  };
                  params.method = 'DELETE';
                  return _context9.abrupt("return", this.fetch(params).then(function (res) {
                    return _this5.handleResponse(res, params, responseOptions);
                  }));

                case 4:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function _delete() {
          return _delete3.apply(this, arguments);
        }

        return _delete;
      }()
    }]);

    return SmartQuery;
  }();

  module.exports = SmartQuery;
  /***/
},
/* 22 */

/***/
function (module, exports) {
  module.exports = require("util");
  /***/
},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var DEBUG_MODES = {
    OFF: 'FALSE',
    VERBOSE: 'VERBOSE'
  };
  module.exports = DEBUG_MODES;
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function formatCampaignDate(dateString, isInclusive) {
    var date = new Date(dateString);
    var dd = date.getDate();
    var MM = date.getMonth() + 1; //January is 0!

    var yyyy = date.getFullYear();
    hh = '00';
    mm = '00';
    ss = '00';

    if (isInclusive) {
      hh = '11';
      mm = '59';
      ss = '59';
    }

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (MM < 10) {
      MM = '0' + MM;
    }

    returnDate = "".concat(yyyy, "-").concat(MM, "-").concat(dd, "T").concat(hh, ":").concat(mm, ":").concat(ss);
    return returnDate;
  }

  module.exports = {
    formatCampaignDate: formatCampaignDate
  };
  /***/
},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = {
    DRAFT: 0,
    PREBOOKED: 1,
    BOOKED: 2,
    SOLD: 3,
    CANCELED: 4
  };
  /***/
}]));